<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="handleStoreChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="会员卡号：">
				<el-input v-model="formInline.vipNo" placeholder="请输入会员卡号" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item label="顾客：">
				<el-select v-model="formInline.customerKeyId" placeholder="请选择顾客" clearable filterable size="small" @change="inputChange">
					<el-option v-for="item in customerInfoList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="修改时间：">
				<el-date-picker
					v-model="timeData"
					size="small"
					value-format="yyyy-MM-dd"
					type="daterange"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@change="timeChange"
				></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button v-if="$checkBtnPermission('/vip/manage', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</el-form-item>
		</el-form>
		<div class="table-minheight">
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
				<template #oldVipNo>
					<el-table-column align="center" label="原卡号" min-width="120">
						<template #default="scope">
							<span style="color: #909399">{{ scope.row.oldVipNo }}</span>
						</template>
					</el-table-column>
				</template>
				<template #newVipNo>
					<el-table-column align="center" label="新卡号" min-width="120">
						<template #default="scope">
							<span style="color: #409eff; font-weight: 600">{{ scope.row.newVipNo }}</span>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</div>
	</div>
</template>

<script>
import { GetVipCardChangeHistoryPageList } from "@/api/vipApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetCustomerListByStore } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
			pageShow: true,
			loading: false,
			listData: [],
			timeData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				customerKeyId: "",
				vipNo: "",
				startTime: "",
				endTime: ""
			},
			storeList: [],
			customerInfoList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "70",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "修改时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "100",
					align: "center",
				},
				{
					prop: "customerInfo.name",
					label: "会员名称",
					minWidth: "100",
					align: "center"
				},
				{
					slot: "oldVipNo",
					label: "原卡号",
					minWidth: "120",
					align: "center"
				},
				{
					slot: "newVipNo",
					label: "新卡号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "customerInfo.phone",
					label: "会员电话",
					width: "120",
					align: "center"
				},
				{
					prop: "remark",
					label: "修改原因",
					minWidth: "150",
					align: "center",
					showOverflowTooltip: true
				},
				{
					prop: "creator",
					label: "操作人",
					width: "120",
					align: "center"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取客户信息列表
		GetCustomerListByStore(val) {
			const paramer = {
				keyId: val
			};
			GetCustomerListByStore(paramer)
				.then((res) => {
					this.customerInfoList = [];
					if (res.code == 1) {
						this.customerInfoList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取客户信息失败!");
				});
		},
		// 门店改变时获取客户列表
		handleStoreChange(val) {
			this.formInline.customerKeyId = "";
			if (val) {
				this.GetCustomerListByStore(val);
			} else {
				this.customerInfoList = [];
			}
		},
		// 时间范围改变
		timeChange(val) {
			if (val && val.length == 2) {
				this.formInline.startTime = val[0] + " 00:00:00";
				this.formInline.endTime = val[1] + " 23:59:59";
			} else {
				this.formInline.startTime = "";
				this.formInline.endTime = "";
			}
			this.inputChange();
		},
		// 获取列表
		getListData() {
			this.loading = true;
			var params = {
				...this.formInline,
				storeKeyId: this.formInline.storeKeyId || null,
				customerKeyId: this.formInline.customerKeyId || null,
				startTime: this.formInline.startTime || null,
				endTime: this.formInline.endTime || null,
				changeType: 1
			};
			GetVipCardChangeHistoryPageList(params)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.loading = false;
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
